import React from 'react';
import {RouteComponentProps, Link} from 'react-router-dom';

import {useTranslation} from 'react-i18next';

import styles from './NotFound.module.css'
import {parseQueryToField} from '../../utils/url';

interface NotFoundProps extends RouteComponentProps {
}

const NotFound = ({location}: NotFoundProps) => {
  const {message} = parseQueryToField(location.search, ['message']);
  const {t} = useTranslation();

  return (
    <div className={styles.root}>
      <div>
        <div className={styles.message} data-manabie="NotFound-message">
          {t(message as any) || t('pageNotExist')}
        </div>
        <Link to="/">{t('backToHome')}</Link>
      </div>
    </div>
  );
};

export default NotFound;
